import DonationCallout from "../components/DonationCallout";
import AboutTeam from "../components/AboutTeam";
import ImmortalChairperson from "../components/ImmortalChairperson";


const About = () => {
  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto text-center mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">About Us</h1>
        <p className="text-base sm:text-lg text-green-700 font-semibold uppercase tracking-wide">
          SHREE NIRMALA SAHAJA YOGA CHARITABLE TRUST
        </p>
      </div>

      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 leading-relaxed text-justify text-sm sm:text-base">
        <p>
          <strong>Shree Nirmala Sahaja Yoga Charitable Trust</strong> is a registered
          (Registration Number - ABKTS9545HE20241) non-profit organization founded with the sole aim
          of promoting inner transformation through the practice of{" "}
          <strong>Sahaja Yoga meditation</strong>. Inspired by the teachings and lifelong service of{" "}
          <strong>Her Holiness Shri Mataji Nirmala Devi</strong>, the trust organizes free
          meditation sessions, public events, awareness camps, and wellness programs for individuals
          from all walks of life.
        </p>

        <p>
          Since its inception, the Trust has been involved in spreading spiritual awareness,
          self-realization, and stress-free living techniques to thousands across urban and rural
          Gujarat, especially in <strong>Ahmedabad and surrounding regions</strong>. With the help
          of dedicated volunteers, teachers, and community members, it functions entirely without
          profit — empowering individuals to discover inner peace and connect to their higher self.
        </p>

        <p>
          All sessions, events, and community services are provided absolutely{" "}
          <strong>free of cost</strong>, in alignment with Shri Mataji's vision that true
          spirituality and self-realization cannot be bought, only shared with love.
        </p>

        <div className="mt-8 bg-green-50 border border-green-100 p-6 rounded-xl shadow-sm">
          <h3 className="text-lg sm:text-xl font-semibold text-green-800 mb-3">Our Mission</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Promote the practice of Sahaja Yoga meditation across India</li>
            <li>Foster stress-free and spiritually balanced communities</li>
            <li>Empower individuals through self-realization and inner transformation</li>
            <li>Conduct free wellness sessions, workshops, and outreach events</li>
            <li>Uplift collective consciousness through silence, joy, and meditation</li>
          </ul>
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm sm:text-base text-gray-600">
            🌸 For more information, collaborations, or volunteering opportunities, feel free to{" "}
            <strong className="text-green-700">contact us.</strong>🌸
          </p>
        </div>

        {/* Team Section */}
        <ImmortalChairperson />
        <AboutTeam />

        {/* Donation CTA */}
        <DonationCallout />
      </div>
    </section>
  );
};

export default About;
